import { render, staticRenderFns } from "./ClusterHeader.vue?vue&type=template&id=5bd7a6c5&scoped=true"
import script from "./ClusterHeader.vue?vue&type=script&lang=js"
export * from "./ClusterHeader.vue?vue&type=script&lang=js"
import style0 from "./ClusterHeader.vue?vue&type=style&index=0&id=5bd7a6c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7a6c5",
  null
  
)

export default component.exports